import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

interface UpdateEndDateModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (endDate: string) => void;
  currentEndDate?: string; // Текущая дата
}

const UpdateEndDateModal: React.FC<UpdateEndDateModalProps> = ({
  open,
  onClose,
  onSubmit,
  currentEndDate,
}) => {
  const [endDate, setEndDate] = useState(currentEndDate || "");

  const handleSubmit = () => {
    onSubmit(endDate);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Update End Date</DialogTitle>
      <DialogContent>
        <TextField
          label="End Date"
          type="date"
          variant="outlined"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!endDate.trim()}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateEndDateModal;
